import { styled } from '@mui/material';
import { StreamLogo } from '../../../../base/components/StreamLogo';

// prettier-ignore
const QrPageLogo = styled(StreamLogo)(({ theme: { spacing, palette, breakpoints } }) => `
  width: 100%;
  height: auto;
  max-height: 125px;
  max-width: 225px;
  ${breakpoints.up("md")} {
    max-height: 250;
    max-width: 300;
  }
  color: ${palette.text.secondary};
`);

export default QrPageLogo;
